<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="navBlog"/>
          </span>
          <div>
            <h1 class="pl-card__title">دسته‌بندی بلاگ</h1>
            <p class="pl-card__sub">
              {{ catId === '0' || catId === 0 ? 'مدیریت دسته‌های اصلی بلاگ' : 'مدیریت زیر‌دسته‌های این دسته' }}
            </p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button
            v-if="catId !== '0' && catId !== 0"
            type="button"
            class="pl-btn pl-btn--ghost"
            @click="$router.push({ path: '/dashboard/news/categories/0' })"
          >
            <CIcon name="iconChevronRight"/>
            <span>بازگشت به اصلی</span>
          </button>
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن دسته جدید</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          class="pl-table"
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'دسته‌ای یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="navBlog"/>
              </span>
              <p class="pl-empty__title">دسته‌ای یافت نشد</p>
              <p class="pl-empty__sub">برای شروع، یک دسته جدید اضافه کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن دسته جدید</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #image="{ item }">
            <td>
              <div class="pl-thumb" v-if="item.image">
                <CImg width="44px" height="44px" :src="item.image"/>
              </div>
              <span v-else class="pl-muted">—</span>
            </td>
          </template>

          <template #name="{ item }">
            <td>
              <span class="pl-name">{{ item.name }}</span>
            </td>
          </template>

          <template #operation="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button
                  type="button"
                  class="pl-btn pl-btn--sm pl-btn--ghost"
                  title="زیردسته‌ها"
                  @click="goSubCategories(item)"
                >
                  <CIcon name="iconList"/>
                  <span>زیردسته</span>
                </button>
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--warn"
                  title="ویرایش"
                  @click="openEditModal(item)"
                >
                  <CIcon name="iconEdit"/>
                </button>
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--danger"
                  title="حذف"
                  @click="delete_item_dialog(item)"
                >
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'افزودن دسته جدید' : 'ویرایش دسته'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12" md="6">
            <CInput
              v-model="name"
              class="required"
              label="نام دسته"
              placeholder="نام دسته"
            />
          </CCol>
          <CCol col="12" md="6">
            <CInput
              v-model="seo_title"
              class="required"
              label="عنوان سئو"
              placeholder="عنوان سئو"
            />
          </CCol>
          <CCol col="12">
            <CTextarea
              v-model="description"
              label="توضیحات دسته"
              placeholder="توضیحات"
              rows="4"
            />
          </CCol>
          <CCol col="12">
            <ImageSelector
              label="تصویر"
              class="required"
              :media_id.sync="file"
              default_archive="blog_category"
              :preview-image="previewImage"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت دسته' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "@/api/http";
import { bus } from '../../../main'

export default {
  name: 'CategoryList',
  computed: {
    catId() {
      return this.$route.params.cat_id
    }
  },
  data() {
    return {
      form_modal: false,
      confirm_delete_name: new Date().getTime() + '_' + this.$vnode.tag,
      name: '',
      seo_title: '',
      file: [],
      color: '',
      previewImage: null,
      description: '',
      items: [],
      fields: [
        { key: 'row', label: '#', _style: 'width:7%' },
        { key: 'image', label: 'تصویر', _style: 'width:10%' },
        { key: 'name', label: 'نام', _style: 'width:30%' },
        { key: 'operation', label: 'عملیات', _style: 'width:35%' }
      ],
      status_form: 0
    }
  },
  mounted() {
    this.get_categories()
    bus.$on(this.confirm_delete_name, (data) => {
      if (data == 'true') {
        this.delete_item()
      } else {
        this.status_form = 0
      }
    })
  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_categories()
    }
  },
  methods: {
    openCreateModal() {
      this.cancel_form()
      this.form_modal = true
    },
    openEditModal(item) {
      this.editDetails(item)
      this.form_modal = true
    },
    closeFormModal() {
      this.form_modal = false
      this.cancel_form()
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form()
      }
    },
    cancel_form() {
      this.name = ''
      this.seo_title = ''
      this.description = ''
      this.previewImage = null
      this.file = []
      this.status_form = 0
    },
    editDetails(item) {
      this.name = item.name
      this.description = item.description
      this.seo_title = item.seo_title
      this.previewImage = item.image
      this.file = [item.image_id]
      this.status_form = item.id
    },
    get_categories() {
      const self = this
      const formData = new FormData()
      formData.append('cat_id', this.$route.params.cat_id)
      axios.post('/api/admin/blog/get_categories', formData, {}).then(function (response) {
        const content_cats = response.data
        self.items = content_cats.orders.map((item, row_id) => {
          return { ...item, row_id }
        })
      }).catch(function (error) {
        console.log(error)
      })
    },
    goSubCategories(item) {
      this.$router.push({ path: '/dashboard/news/categories/' + item.id })
    },
    login() {
      const self = this
      const formData = new FormData()
      let url
      if (this.status_form == 0) {
        url = '/api/admin/blog/insert_category'
      } else {
        url = '/api/admin/blog/update_category'
        formData.append('id', this.status_form)
      }

      formData.append('image', this.file[0])
      formData.append('name', this.name)
      formData.append('cat', this.$route.params.cat_id)
      formData.append('seo_title', this.seo_title)
      formData.append('description', this.description)

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res)
        if (res.data.error == 0) {
          self.closeFormModal()
          self.get_categories()
        }
      }).catch(function (error) {
        self.$root.modal_component.show_danger_toast('لطفا همه موارد را تکمیل کنید')
        console.log(error)
      })
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(
        this.$t('warning'),
        this.$t('deleteMessage'),
        [this.$t('ok')],
        this.confirm_delete_name
      )
      this.status_form = item.id
    },
    delete_item() {
      const self = this
      const formData = new FormData()
      formData.append('id', this.status_form)

      axios.post('/api/admin/blog/delete_category', formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res)
        self.status_form = 0
        self.get_categories()
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>
